export default {
   baseURL: process.env.NODE_ENV !== 'production' ?'https://www.houqinban.cn/api/'  : 'https://www.houqinban.cn/api/', //开发环境接口地址与线上环境接口地址
    //baseURL: process.env.NODE_ENV !== 'production' ?'http://116.206.94.117:8195/'  : 'http://116.206.94.117:8195/', //开发环境接口地址与线上环境接口地址
    // 下面就是和用户相关的一些接口地址
    login: 'common/login',//登录=-
    scroll:'homePage/getViewPaperList',//首页-获取轮播图列表
    delScrool:'homePage/delViewPaper',//首页-删除轮播图
    uploadViewPaper:'homePage/uploadViewPaper',//首页-上传轮播图
    productList :'/homePage/getProductList',//首页-获取产品体系列表
    delSysProduct:'sysProduct/del',//产品体系-（批量）删除产品体系
    addSysProduct:'sysProduct/add',//产品体系-添加产品体系
    editSysProduct:'sysProduct/edit',//产品体系-修改产品体系
    getNewsList:'homePage/getNewsList',//首页-获取首页公司新闻列表
    addSysNews:'sysNews/add',//新闻中心-新增新闻或行业动态
    editSysNews:'sysNews/edit',//新闻中心-编辑新闻或行业动态
    delSysNews:'sysNews/del',//新闻中心-（批量）删除新闻或行业动态
    getBusinessList:'homePage/getBusinessList',//首页-获取首页行业应用列表
    getSysNews:'sysNews/get',//新闻中心-获取公司新闻或行业动态列表
    uploadIllustration:'common/uploadIllustration',//通用-上传文本插图
    addBusiness:'sysIndustry/addBusiness',//行业应用-添加行业
    editBusiness:'sysIndustry/editBusiness',//行业应用-编辑行业
    delBusiness:'sysIndustry/delBusiness',//行业应用-删除行业
    getIndustry:'sysIndustry/getIndustry',//行业应用-获取行业应用
    addIndustry:'sysIndustry/addIndustry',//行业应用-新增行业应用
    editIndustry:'sysIndustry/editIndustry',//行业应用-编辑行业应用
    delIndustry:'sysIndustry/delIndustry',//行业应用-删除行业应用
    getRecruitList:'sysTrain/getRecruitList',//人才招聘-人才招聘-获取招聘信息列表
    addRecruit:'sysTrain/addRecruit',//人才招聘-人才招聘-添加招聘信息
    editRecruit:'sysTrain/editRecruit',//人才招聘-人才招聘-编辑招聘信息
    delRecruit:'sysTrain/delRecruit',//人才招聘-人才招聘-（批量）删除招聘信息列表
    getSysTrain:'sysTrain/get',//人才招聘-培训发展-获取
    addSysTrain:'sysTrain/add',//人才招聘-培训发展-添加
    editSysTrain:'sysTrain/edit',//人才招聘-培训发展-编辑
    delSysTrain:'sysTrain/del',//人才招聘-培训发展-删除
    getCompanyInfo:'company/getCompanyInfo',//公司信息-获取公司信息
    addCompanyInfo:'company/addCompanyInfo',//公司信息-添加公司信息
    editCompanyInfo:'company/editCompanyInfo',//公司信息-编辑公司信息
    getCompanyIntro:'company/getCompanyIntro',//关于我们-获取公司简介、企业文化
    addCompanyIntro:'company/addCompanyIntro',//关于我们-添加公司简介、企业文化
    editCompnayIntro:'company/editCompnayIntro',//关于我们-编辑公司简介、企业文化
    getHonorPic:'company/getHonorPic',//关于我们-获取荣誉资质图
    addHonorPic:'company/addHonorPic',//关于我们-添加荣誉资质图
    delHonorPic:'company/delHonorPic',//关于我们-删除荣誉资质图
    sendInfoToCompany:'homePage/sendInfoToCompany',//联系我们
    editHonorPic:'company/editHonorPic',//编辑荣誉资质图
    editIcon:'sysProduct/editIcon',//编辑产品体系的插图
    uploadHonorPic:'company/uploadHonorPic',//上传荣誉资质图
    sortHonorPic:'company/sortHonorPic',//荣誉资质图排序
    addProductType:'sysProduct/addProductType',//体系类别-添加
    editProductType:'sysProduct/editProductType',//体系类别-修改
    listProductType:'sysProduct/listProductType',//体系类别-获取列表
    delProductType:'sysProduct/delProductType',//体系类别-(批量)删除

  };